// src/Layout/PrintLayout.jsx
import React, { useEffect } from "react";

export default function PrintLayout({ children }) {
  return <div style={{ padding: "20px" }}>{children}</div>;
}
